import * as React from "react";

const Target: React.FC = () => {
    return (
        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M23.52 11.52h-2.16a9.38 9.38 0 0 0-8.88-8.88V.48A.475.475 0 0 0 12 0a.478.478 0 0 0-.48.48v2.16a9.38 9.38 0 0 0-8.88 8.88H.48A.478.478 0 0 0 0 12c0 .264.216.48.48.48h2.16a9.383 9.383 0 0 0 8.88 8.88v2.16c0 .264.216.48.48.48.269 0 .48-.216.48-.48v-2.16a9.383 9.383 0 0 0 8.88-8.88h2.16c.269 0 .48-.216.48-.48a.475.475 0 0 0-.48-.48Zm-12 6.931a6.477 6.477 0 0 1-5.971-5.971h2.918a3.58 3.58 0 0 0 3.053 3.053v2.918Zm0-9.989a3.57 3.57 0 0 0-3.048 3.058H5.549a6.477 6.477 0 0 1 5.971-5.976v2.918Zm.96 9.99v-2.924a3.564 3.564 0 0 0 3.053-3.048h2.923a6.477 6.477 0 0 1-5.976 5.971Zm3.053-6.932a3.57 3.57 0 0 0-3.053-3.053V5.544a6.482 6.482 0 0 1 5.976 5.976h-2.923Z"
                fill="#B5111A"
                fillRule="nonzero"
            />
        </svg>
    );
};

export default React.memo(Target);
